import { render, staticRenderFns } from "./copy-to-clipboard.component.vue?vue&type=template&id=b53940da&scoped=true"
import script from "./copy-to-clipboard.component.vue?vue&type=script&lang=ts"
export * from "./copy-to-clipboard.component.vue?vue&type=script&lang=ts"
import style0 from "./copy-to-clipboard.component.vue?vue&type=style&index=0&id=b53940da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53940da",
  null
  
)

export default component.exports